import { formatDayMonthYear } from "@/lib/dates";

/// Mirrors `SPACE_DELETION_GRACE_PERIOD_SECS` and `ORG_DELETION_GRACE_PERIOD_SECS`:
/// one 30-day clock for a deleted org or space, its sub-spaces, models and
/// tables (D53/D54). Only ever used to render a date — the server owns the
/// real deadline, and the schedule responses carry `purge_at` where it matters.
export const GRACE_DAYS = 30;

const plusDays = (scheduledAt: string, days: number): string => {
  const d = new Date(scheduledAt);
  d.setDate(d.getDate() + days);
  return formatDayMonthYear(d.toISOString());
};

/// Takes the moment a window opened and renders when it closes. Pass a
/// `purge_at` from a schedule response to `formatDayMonthYear` instead — that
/// is already the deadline, and adding the grace again puts it a month late.
export const purgeDate = (scheduledAt: string): string =>
  plusDays(scheduledAt, GRACE_DAYS);
